// extracted by mini-css-extract-plugin
export default {"container":"contanier_container__-q8gy"};